import React, { useEffect, useState, useRef } from "react";
import GridHeader from "./GridHeader";
import GridItem from "./GridItem";
import { Pagination } from "@material-ui/lab";
import { Grid, makeStyles } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DMSelect from "../DMSelect";
import { orderBy } from "lodash";

const DMGrid = (props) => {
  const useStyles = makeStyles((theme) => ({
    noDataFound: {
      fontSize: "20px",
      display: "flex",
      justifyContent: "center",
      padding: "40px 0",
      cursor: "pointer",
      width: "100%",
    },
  }));

  const classes = useStyles();
  const dragRef = useRef();

  const [sortCol, setSortCol] = useState("");
  const [sortKey, setSortKey] = useState("");
  const [sortType, setSortType] = useState("");

  const [unSortedData, setUnSortedData] = useState([]);

  useEffect(() => {
    if (props?.data?.length) {
      setUnSortedData(props.data);
    }
  }, [props.data]);
  const [data, setData] = useState(props.data);
  const [loading, setLoading] = useState(props.loading);


  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);


  const sortAcs = (arr, sortType, sortKey) => {
    if (sortType && sortKey && props.data?.length) {
      let temp = orderBy(
        arr,
        [(sortKeydata) => isNaN(sortKeydata[sortKey]) ? sortKeydata[sortKey]?.toString()?.toLowerCase() : sortKeydata[sortKey]],
        [sortType]
      );
      setData(temp);
    } else {
      setData([...props.data]);
    }
  };

  const handleSorting = (col, key = null) => {
    let type = "";
    let tempCol = "";
    if (col === sortCol && key) {
      if (sortType === "" || sortType === "desc") {
        type = "asc";
      } else if (sortType === "asc") {
        type = "desc";
      }
      tempCol = col;
    } else {
      type = "asc";
      tempCol = col;
    }
    setSortCol(tempCol);
    setSortKey(key);
    setSortType(type);
  };

  useEffect(() => {
    if (sortCol && sortKey) {
      sortAcs(props.data, sortType, sortKey);
    }
  }, [sortType, sortCol, sortKey]);

  return (
    <>
      <Grid
        container
        alignItems="center"
        justify="space-between"
        style={{ marginBottom: "16px" }}
      >
      </Grid>
      <GridHeader
        items={props.headers}
        className={props.headerClassName}
        handleSorting={handleSorting}
        // sortType={sortType}
        // sortCol={sortCol}
      />
      {loading && (
        <Grid
          container
          alignItems="center"
          justify="right"
          alignContent="center"
        >
          <CircularProgress />
        </Grid>
      )}
      {props?.data?.length === 0 && (
        <div className={classes.noDataFound}>NO DATA FOUND</div>
      )}
      {!props?.draggable &&
        props?.data?.length !== 0 &&
        data.map(
          (row) => {
            return (
              <GridItem
                key={row.rowKey}
                highlight={row.highlight}
                items={row.rowValue}
                className={props.headerClassName}
              />
            );
          }
        )}
    </>
  );
};

export default DMGrid;
